import {
  AVAILABILITY_STATUSES,
  BOARDS_ENUMS,
  BOARDS_ID,
  BOARDS_ID_TO_URLS_MAP,
  RESERVATIONS_TYPES,
  TENANT_NAMES,
} from '@constants';
import {
  formatAmount,
  formatDate,
  formatVehicleStage,
  timeFromNow,
} from '@utils';
import { AVAILABLE_HISTORY_ITEMS } from 'components/common/InstaTaskHistory/constants';
import { URLS } from 'layouts/DrawerLayout/constants';
import { pickBy, identity } from 'lodash-es';

export const handleUsers = (data) => {
  if (!data) {
    return [];
  }
  const users = data?.map((item) => {
    return {
      createdAt: item.createdAt
        ? formatDate(item.createdAt, 'dd/MM/yyyy')
        : '-',
      updatedAt: item.updatedAt
        ? formatDate(item.updatedAt, 'dd/MM/yyyy')
        : '-',
      docs: item.docs || '-',
      email: item.email || '-',
      firstName: item.firstName || '-',
      gateway: item.gateway || '-',
      lastName: item.lastName || '-',
      phoneNumber: item.phoneNumber || '-',
      internalId: item?.internalId,
      id: item.id,
    };
  });
  return users;
};

export const handleUserWithSubs = (response) => {
  const data = { ...response };
  const user = data?.user;
  const featureFlags = data?.featureFlags;

  data.details = {
    createdAt: {
      label: 'Created At:',
      renderedValue: data?.createdAt
        ? formatDate(data.createdAt, 'dd/MM/yyyy')
        : '-',
      onEditField: null,
    },
    updatedAt: {
      label: 'Updated At:',
      renderedValue: data?.updatedAt
        ? formatDate(data.updatedAt, 'dd/MM/yyyy')
        : '-',
      onEditField: null,
    },
    email: {
      label: 'E-mail:',
      renderedValue: data?.email || '-',
      onEditField: null,
    },
    telephoneNumber: {
      canEdited: true,
      label: 'Mobile Phone:',
      type: 'text',
      renderedValue: user?.phoneNumber || '-',
      defaultValue: user?.phoneNumber,
      instructions:
        'Telephone number should be in E.164 format e.g. +3069xxxxxxxx',
      onEditField: null,
      fieldWrapperStyle: {
        width: '100%',
      },
    },
  };
  data.billingInfoRaw = data.billingInfo;
  // TODO: this should be in a selector
  data.billingInfo = data.billingInfo?.reduce((acc, cur) => {
    const normalizedBillingItem = pickBy(
      {
        id: cur.billingId,
        firstName: {
          label: 'First Name:',
          renderedValue: cur.firstName || '-',
          defaultValue: cur.firstName,
          onEditField: null,
          canEdited: true,
          type: 'text',
          placeholder: '',
          rules: {
            required: '* This field is required',
          },
          fieldWrapperStyle: {
            width: '100%',
          },
          hidden: false,
        },
        lastName: {
          label: 'Last Name:',
          renderedValue: cur.lastName || '-',
          defaultValue: cur.lastName,
          onEditField: null,
          canEdited: true,
          type: 'text',
          placeholder: '',
          rules: {
            required: '* This field is required',
          },
          fieldWrapperStyle: {
            width: '100%',
          },
          hidden: false,
        },
        vat: {
          label: 'Tax code:',
          renderedValue: cur.vat || '-',
          defaultValue: cur.vat,
          onEditField: null,
          canEdited: true,
          type: 'text',
          placeholder: '',
          rules: {
            required: '* This field is required',
          },
          fieldWrapperStyle: {
            width: '100%',
          },
          hidden: false,
          // TODO: enable after permission handle
          // disabled: !!cur.vat,
        },
        companyName: cur.companyName
          ? {
              label: 'Business Name:',
              renderedValue: cur.companyName || '-',
              defaultValue: cur.companyName,
              onEditField: null,
              canEdited: true,
              type: 'text',
              placeholder: '',
              rules: {
                required: '* This field is required',
              },
              fieldWrapperStyle: {
                width: '100%',
              },
              hidden: false,
            }
          : undefined,
        doi: {
          label: 'D.O.Y:',
          renderedValue: cur.doi || '-',
          defaultValue: cur.doi,
          onEditField: null,
          canEdited: true,
          type: 'text',
          placeholder: '',
          rules: {
            required: '* This field is required',
          },
          fieldWrapperStyle: {
            width: '100%',
          },
          hidden: false,
        },
        activity: {
          label: 'Activity:',
          renderedValue: cur.activity || 'Ιδιώτης',
          defaultValue: cur.activity || 'Ιδιώτης',
          onEditField: null,
          canEdited: true,
          type: 'text',
          placeholder: '',
          rules: {
            required: '* This field is required',
          },
          fieldWrapperStyle: {
            width: '100%',
          },
          hidden: false,
        },
        phoneNumber: {
          label: 'Phone Number:',
          renderedValue: cur.phoneNumber || '-',
          defaultValue: cur.phoneNumber,
          onEditField: null,
          canEdited: true,
          type: 'text',
          placeholder: '',
          rules: {
            required: '* This field is required',
          },
          fieldWrapperStyle: {
            width: '100%',
          },
          hidden: false,
        },
        address: {
          label: 'Street Address:',
          renderedValue: cur.address || '-',
          defaultValue: cur.address,
          onEditField: null,
          canEdited: true,
          type: 'text',
          placeholder: '',
          rules: {
            required: '* This field is required',
          },
          fieldWrapperStyle: {
            width: '100%',
          },
          hidden: false,
        },
        email: {
          label: 'E-mail:',
          renderedValue: cur.email || '-',
          defaultValue: cur.email,
          onEditField: null,
          canEdited: true,
          type: 'text',
          placeholder: '',
          rules: {
            required: '* This field is required',
            pattern: {
              value: `${/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i}`,
              message: 'invalid email address',
            },
          },
          fieldWrapperStyle: {
            width: '100%',
          },
          hidden: false,
        },
        postalCode: {
          label: 'Postal Code:',
          renderedValue: cur.postalCode || '-',
          defaultValue: cur.postalCode,
          onEditField: null,
          canEdited: true,
          type: 'text',
          placeholder: '',
          rules: {
            required: '* This field is required',
          },
          fieldWrapperStyle: {
            width: '100%',
          },
          hidden: false,
        },
      },
      identity
    );
    acc.push(normalizedBillingItem);
    return acc;
  }, []);

  data.featureFlags = {
    isUserAppEnabled: {
      label: 'IS USER APP ENABLED',
      renderedValue: featureFlags?.isUserAppEnabled,
      hasSwitch: true,
    },
  };

  return data;
};

export const handleUserSubscriptions = (
  response,
  subscriberId,
  servicePointsMap
) => {
  const formatReservationType = (reservationType) => {
    // Find the reservation type by matching the value
    const reservationTypeEntry = Object.values(RESERVATIONS_TYPES).find(
      (type) => type.value === reservationType
    );
    return reservationTypeEntry?.text || '-';
  };

  const formatAvailabilityStatus = (availabilityStatus) => {
    // Find the availability status by matching the value
    const availabilityEntry = Object.values(AVAILABILITY_STATUSES).find(
      (status) => status.value === availabilityStatus
    );
    return availabilityEntry?.text || '-';
  };

  return response.map((item) => {
    const currentSubscriber = item?.subscribers.find(
      (subscriber) => subscriber.id === subscriberId
    );
    const currentSubscription = currentSubscriber?.subscriptions.find(
      (subscr) => subscr.id === item.id
    );

    return {
      role: currentSubscription?.role === 1 ? 'OWNER' : 'DRIVER',
      createdAt: item.createdAt
        ? formatDate(item.createdAt, 'dd/MM/yyyy')
        : '-',
      updatedAt: item.updatedAt
        ? formatDate(item.updatedAt, 'dd/MM/yyyy')
        : '-',
      promisedDeliveryDate: item.promisedDeliveryDate
        ? formatDate(item.promisedDeliveryDate, 'dd/MM/yyyy HH:mm')
        : '',
      promisedDeliveryDateUntil: item.promisedDeliveryDateUntil
        ? formatDate(item.promisedDeliveryDateUntil, 'dd/MM/yyyy HH:mm')
        : '',
      endContractDate: item.endContractDate
        ? formatDate(item.endContractDate, 'dd/MM/yyyy')
        : '-',
      deliveryDate: item.deliveryDate
        ? formatDate(item.deliveryDate, 'dd/MM/yyyy')
        : '-',
      promisedReturnDate: item.promisedReturnDate
        ? formatDate(item.promisedReturnDate, 'dd/MM/yyyy')
        : '-',
      returnDate: item.returnDate
        ? formatDate(item.returnDate, 'dd/MM/yyyy')
        : '-',
      vehicle: item?.vehicle
        ? `${item?.vehicle?.manufacturer || ''} - ${item?.vehicle?.model || ''}`
        : '-',
      vehiclePlate: item?.vehicle?.plate || item?.vehiclePlate || '-',
      amount: item?.rules?.[0]?.amount?.value
        ? formatAmount(item?.rules?.[0]?.amount?.value)
        : '-',
      pipedriveId: item?.pipedriveId || '-',
      pipedriveUrl: item?.pipedriveUrl,
      labels: item?.labels || [],
      id: item.id,
      internal_id: item.internal_id,
      type: item.type,
      status: item.status,
      // as owner we define the subscriber who has subscription with role === 1 (owner)
      owner:
        item?.subscribers?.find((subscriber) =>
          subscriber?.subscriptions?.find(
            (subscription) =>
              subscription.role === 1 && subscription.id === item.id
          )
        )?.email || '-',
      carId: item?.vehicle?.id,
      vehicleInternalId:
        item?.vehicle?.internalId || item?.vehicleInternalId || '-',
      location:
        servicePointsMap[item?.vehicle?.location?.name]?.name ||
        item?.vehicle?.location?.name ||
        '-',
      stage: item?.vehicle?.procurement?.currentStageId
        ? formatVehicleStage(item?.vehicle?.procurement?.currentStageId)
        : '-',
      reservationType: item?.vehicle?.reservationType
        ? formatReservationType(item?.vehicle?.reservationType)
        : '-',
      availabilityStatus: item?.vehicle?.availability?.status
        ? formatAvailabilityStatus(item?.vehicle?.availability?.status)
        : '-',
      plannedDownpaymentDate: item?.vehicle?.procurement?.plannedDownpaymentDate
        ? formatDate(
            item?.vehicle?.procurement?.plannedDownpaymentDate,
            'dd/MM/yyyy'
          )
        : '-',
      erfudd: item?.vehicle?.availability?.erfudd
        ? formatDate(item?.vehicle?.availability?.erfudd, 'dd/MM/yyyy')
        : '-',
    };
  });
};

export const handleOrders = (data = [], userId = '') => {
  return data
    .map((item) => ({
      rawItem: item,
      ...item,
      name: item.orderName || '-',
      text: item.orderName || '-',
      value: item.id,
      createdAt: item?.createdAt
        ? formatDate(item?.createdAt, 'dd-MM-yyyy')
        : '-',
      customerName: `${item.firstName} ${item.lastName}`,
      customerId: item.userId,
    }))
    .filter((item) => userId && item.customerId === userId);
};

export const getSellRequestsPayload = (id) => ({
  page: 1,
  pageSize: 1000,

  type: 0,
  field: null,
  operator: null,
  boardId: BOARDS_ID.SELL_REQUESTS,
  value: [
    {
      type: 5,
      field: 'boardId',
      operator: 0,
      value: BOARDS_ID.SELL_REQUESTS,
    },
    {
      type: 5,
      field: 'customFields.userId',
      operator: 0,
      value: id,
    },
  ],
});

export const getLeasingBuyoutsPayload = (id) => ({
  page: 1,
  pageSize: 1000,

  type: 0,
  field: null,
  operator: null,
  boardId: BOARDS_ID.BUY_OUT,
  value: [
    {
      type: 5,
      field: 'boardId',
      operator: 0,
      value: BOARDS_ID.BUY_OUT,
    },
    {
      type: 5,
      field: 'customFields.userId',
      operator: 0,
      value: id,
    },
  ],
});

export const handleUser = (data = {}) => {
  return {
    id: data.id || '-',
    internalId: data.internalId || '-',
    email: data.email || '-',
    createdAt: data.createdAt ? formatDate(data.createdAt, 'dd/MM/yyyy') : '-',
    updatedAt: data.updatedAt ? formatDate(data.updatedAt, 'dd/MM/yyyy') : '-',
    driversLicenseIssueDate: data.driversLicenseIssueDate
      ? formatDate(data.driversLicenseIssueDate, 'dd/MM/yyyy')
      : '-',
    dateOfBirth: data.dateOfBirth
      ? formatDate(data.dateOfBirth, 'dd/MM/yyyy')
      : '-',
    driversLicenseNumber: data.driversLicenseNumber || '-',
    rawDriversLicenseIssueDate: data.driversLicenseIssueDate,
    rawDateOfBirth: data.dateOfBirth,
    rawDriversLicenseNumber: data.driversLicenseNumber,
    firstName: data.firstName || '',
    lastName: data.lastName || '',
    phoneNumber: data.phoneNumber || '',
    phoneNumbers: data.phoneNumbers || [],
    emails: data.emails || [],
    lang: data.lang || '',
    gateway: data.gateway || '',
    driverDocuments:
      data.docs
        ?.filter(
          (doc) =>
            doc.type === 'DriverLicence' ||
            doc.type === 'PersonalIdentification'
        )
        .map((doc) => {
          const document = { ...doc };
          document.fileName = '-';
          return {
            ...document,
            uploadedAt: formatDate(document?.createdAt, 'dd/MM/yyyy HH:mm:ss'),
          };
        }) || [],
    financialDocuments:
      data.docs
        ?.filter((doc) => doc.type !== 'DriverLicence')
        ?.filter((doc) => doc.type !== 'PersonalIdentification')
        .map((doc) => {
          const document = { ...doc };
          document.fileName = '-';
          return {
            ...document,
            uploadedAt: formatDate(document?.createdAt, 'dd/MM/yyyy HH:mm:ss'),
          };
        }) || [],
    status: data.status ?? -1,
  };
};

export const handleUserBookings = (bookings = []) => {
  return bookings.map((booking) => {
    return {
      id: booking?.id,
      created_at: booking?.created_at
        ? formatDate(booking?.created_at, 'dd/MM/yyyy')
        : '-',
      stage: booking?.stage,
      timeAgo: booking?.created_at ? timeFromNow(booking?.created_at) : '-',
      email: booking?.user?.email || '-',
      pipeDriveId: booking?.pipedrive?.id || '-',
      pipeDriveUrl: booking?.pipedrive?.url || '',
      is_active: booking?.is_active,
      region: booking?.region || '-',
      contract: booking?.contract_details?.contract || '-',
      contractPeriod: booking?.contract_details?.contract_period || '-',
      phoneNumber: booking?.user?.phone_number || '-',
      vehicle: booking?.vehicle?.title || '-',
      skuId: booking?.vehicle?.id,
      origin: booking?.origin,
      fee: formatAmount(booking?.final_values?.fee),
      initialFee: formatAmount(booking?.sku_values?.fee),
      tenant: TENANT_NAMES[booking?.tenant],
    };
  });
};

export const handleUserCreditScore = (creditScore = {}) => {
  return {
    b2c: {
      deposit: {
        ...creditScore.b2c?.deposit,
        total: creditScore.b2c?.deposit?.total || '-',
      },
      standingOrder: {
        ...creditScore.b2c?.standingOrder,
        total: creditScore.b2c?.standingOrder?.total || '-',
      },
    },
    b2b: {
      deposit: {
        ...creditScore.b2b?.deposit,
        total: creditScore.b2b?.deposit?.total || '-',
      },
      standingOrder: {
        ...creditScore.b2b?.standingOrder,
        total: creditScore.b2b?.standingOrder?.total || '-',
      },
    },
  };
};

export const handleUserLeasingBuyouts = (leasingBuyouts = []) => {
  return leasingBuyouts.map((leasingBuyout) => {
    return {
      id: leasingBuyout?.id,
      status: leasingBuyout?.status,
      createdAt: leasingBuyout?.createdAt
        ? formatDate(leasingBuyout.createdAt, 'dd/MM/yyyy')
        : '-',
      finalPrice: leasingBuyout?.customFields?.finalPrice?.number
        ? new Intl.NumberFormat('el-GR', {
            style: 'currency',
            currency: 'EUR',
          }).format(leasingBuyout?.customFields?.finalPrice?.number)
        : '-',
      loan: leasingBuyout?.customFields?.loan,
      loanContractId: leasingBuyout?.customFields?.loanContractId,
      carId: leasingBuyout?.customFields?.carId || '-',
      plate: leasingBuyout?.customFields?.vehiclePlate || '-',
    };
  });
};

const BOARD_ID_VALUE_TO_KEY = Object.entries(BOARDS_ID).reduce(
  (acc, [key, val]) => {
    acc[val] = key;
    return acc;
  },
  {}
);

const BOARD_META_BY_ID = Object.values(BOARDS_ENUMS).reduce((acc, board) => {
  if (!board?.board) return acc;

  acc[board.board] = {
    name: board.text,
    url: BOARDS_ID_TO_URLS_MAP[BOARD_ID_VALUE_TO_KEY[board.board]] || null,
  };

  return acc;
}, {});

export const handleInfiniteQueryUserData = (
  data,
  loggedInUser,
  handleChangelogItem,
  isSystemActor,
  getAssigneeName
) => {
  if (!data || !data.length) return [];

  return data.map((item) => {
    const type = item?.type;

    if (type === AVAILABLE_HISTORY_ITEMS.task) {
      const renderType = 'userTask';

      const boardType = item?.data?.boardType;

      const boardMeta = BOARD_META_BY_ID[boardType] || {};

      let ticketNumber = item?.data?.ticketNumber || '';

      if (
        boardType === BOARDS_ID.INSTATRADES ||
        boardType === BOARDS_ID.SERVICE_INBOX ||
        boardType === BOARDS_ID.SUBSCRIPTIONS
      ) {
        ticketNumber = item?.data?.resourceId || '';
      }

      const ticketUrl =
        boardMeta.url && ticketNumber
          ? `${boardMeta.url}/${ticketNumber}`
          : null;
      const status = item?.data?.status;
      const assigneeEmail = item?.data?.assignee || '';
      const assignee = getAssigneeName(assigneeEmail);
      const carId =
        item?.data?.vehicleInternalId || item?.data?.vehicleId || '';
      const carLinkId =
        item?.data?.vehicleId || item?.data?.vehicleInternalId || '';
      const carIdUrl = carLinkId
        ? `${URLS.fleetVehicles}/${carLinkId || ''}`
        : '';
      const title = item?.data?.vehicleDescription || '';
      const sku = item?.data?.vehicleSku || '';
      const skuUrl = sku ? `${URLS.catalogCars}/${sku || ''}/edit` : '';
      const plate = item?.data?.vehiclePlate || '';

      return {
        ...(item?.data || {}),
        type: renderType,
        ticketNumber,
        status,
        board: boardMeta.name || boardType,
        url: ticketUrl,
        assignee,
        carId,
        carIdUrl,
        title,
        sku,
        skuUrl,
        plate,
      };
    }

    if (type === AVAILABLE_HISTORY_ITEMS.changelog) {
      const itemData = item?.data || {};

      const changelogInitialItem = {
        ...itemData,
        fieldName: itemData?.field,
        valueFrom: itemData?.from,
        valueTo: itemData?.to,
      };

      const changelogItem = handleChangelogItem(changelogInitialItem);

      const changelogActor = changelogItem?.actor || '';

      const actor = isSystemActor(changelogActor)
        ? changelogActor
        : getAssigneeName(changelogActor);

      return {
        type,
        ...itemData,
        ...(changelogItem || {}),
        actor,
      };
    }

    if (type === AVAILABLE_HISTORY_ITEMS.email) {
      const itemData = item?.data || {};

      const url =
        itemData?.threadId && itemData?.mailboxId
          ? `${URLS.communication}/${itemData?.threadId}?mailboxId=${itemData?.mailboxId}`
          : '';

      const status = itemData?.status || '';

      const sender =
        itemData?.emailSender?.name ||
        `${itemData?.senderFirstName || ''} ${
          itemData?.senderLastName || ''
        }`.trim() ||
        '-';

      const subject = itemData?.subject || '';

      const receivers =
        itemData?.emailReceivers?.length > 0
          ? itemData?.emailReceivers.map((emailReceivers) => {
              return {
                ...emailReceivers,
                id: emailReceivers?.email || '',
                name: emailReceivers?.name || '',
                email: emailReceivers?.email || '',
              };
            })
          : [];
      return {
        ...itemData,
        url,
        type,
        status,
        subject,
        sender,
        receivers,
      };
    }

    if (type === AVAILABLE_HISTORY_ITEMS.sms) {
      const boardType = item?.data?.boardType;

      const boardMeta = BOARD_META_BY_ID[boardType] || {};

      const resourceId = item?.data?.resourceId || '';

      const ticketUrl =
        boardMeta.url && resourceId ? `${boardMeta.url}/${resourceId}` : null;
      const sender = getAssigneeName(item?.data?.sender);
      return {
        type,
        sender,
        ...(item.data || {}),
        board: boardMeta.name || boardType,
        url: ticketUrl,
      };
    }

    if (type === AVAILABLE_HISTORY_ITEMS.comment) {
      const itemData = item?.data || {};

      return {
        type,
        ...itemData,
        isLoggedInUser: itemData?.author === loggedInUser?.email,
        userName: getAssigneeName(itemData.author),
      };
    }
    return {
      type,
      ...(item.data || {}),
    };
  });
};

export const handleUserSMS = ({ sms }) => {
  if (!sms?.length) return [];

  return sms.map((item) => ({
    createdAt: item?.CreatedAt,
    message: item?.Message || '',
    receiver: item?.SentTo || '',
    status: item?.Status || item?.status || '',
    type: 'sms',
    board: 'SMS',
    sender: item?.CreatedBy || '',
  }));
};

export const handleUserComments = (data, loggedInUser, getAssigneeName) => {
  if (!data?.length) return [];

  return (
    data?.map((item) => {
      return {
        id: item.id,
        type: 'comment',
        comment: item.comment,
        createdAt: item.createdAt,
        createdBy: item.author,
        userName: getAssigneeName(item.author),
        author: {
          email: item.author,
        },
        isLoggedInUser: item.author === loggedInUser?.email,
      };
    }) || []
  );
};
